import { LinkId } from '../../common/AnalyticsContext/LinkId';
import { StyledLink } from './InfoModal/InfoModal.styles';

export const BUPA_PLATINUM = 'Bupa Members First Platinum';

export const PROVIDERS = [
  {
    provider: 'BUPA',
    logo: 'public/images/Bupa-white-logo_20201119091043.svg',
    trackingId: LinkId.PROMINENT_INSURANCE_FILTER_BUPA,
    gapFree: false,
  },
  {
    provider: 'HBF',
    logo: 'public/images/hbf-logo_20180212090349.svg',
    trackingId: LinkId.PROMINENT_INSURANCE_FILTER_HBF,
    gapFree: true,
    term: 'Member Plus',
    description: (
      <>
        <StyledLink
          to="https://www.hbf.com.au/health-insurance/extras-insurance/dental"
          target="_blank"
        >
          Eligible
        </StyledLink>{' '}
        HBF members receive one
        <div>
          <strong>gap free check-up and clean</strong>
        </div>{' '}
        per year when visiting a HBF Member Plus provider.
      </>
    ),
  },
  {
    provider: 'HCF',
    logo: 'public/images/HCF-Logo_20201119072747.svg',
    trackingId: LinkId.PROMINENT_INSURANCE_FILTER_HCF,
    gapFree: false,
  },
  {
    provider: 'Medibank',
    logo: 'public/images/Medibank_Logo_20201119074048.svg',
    trackingId: LinkId.PROMINENT_INSURANCE_FILTER_MEDIBANK,
    gapFree: true,
    term: "Members' Choice",
    description: (
      <>
        <StyledLink
          to="https://www.medibank.com.au/health-insurance/why-medibank/members-choice/dentists-network/"
          target="_blank"
        >
          Eligible
        </StyledLink>{' '}
        Medibank members receive at least one
        <div>
          <strong>gap free check-up and clean</strong>
        </div>{' '}
        per year when visiting a Medibank Members' Choice provider.
      </>
    ),
  },
  {
    provider: 'NIB',
    logo: 'public/images/nib-logo-vector_20201119075037.svg',
    trackingId: LinkId.PROMINENT_INSURANCE_FILTER_NIB,
    gapFree: false,
  },
];
